module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"remove":"Remove","attention":"Attention!","content will be removed":"The content of this box will be deleted. Continue?"}}')
  delete Component.options._Ctor
}
